import Link from "next/link"
import Image from "components/Image"
import Modal from "components/Modal"
import useModal from "utilities/useModal"
import richText from "utilities/richText"
import slugify from "utilities/slugify"
import isRichTextValid from "utilities/isRichTextValid"

export function TeamMember({ image, name, credentials, title, bio, board_title, group }) {
  return (
    <div className="team-member z-10 flex flex-col">
      <Image
        src={image?.filename?.length ? image.filename : "/assets/team-member-placeholder.png"}
        alt={image?.alt ?? ""}
        placeholder={image?.blurDataURL ? "blur" : "empty"}
        blurDataURL={image?.blurDataURL}
        width={200}
        height={200}
        className="relative top-6 mx-auto aspect-square rounded-full border-8 border-white object-cover object-top"
      />
      <div className="basis-full rounded-10 bg-white px-6 pb-8 pt-10 shadow-md">
        {isRichTextValid(bio) ? (
          <Link href={`#${slugify(`${name}-${group}`)}`}>
            <h3 className="pb-2 text-center font-tertiary text-m3 leading-7 text-teal-dark hover:underline">
              {name}
              {credentials ? `, ${credentials}` : null}
            </h3>
          </Link>
        ) : (
          <h3 className="pb-2 text-center font-tertiary text-m3 leading-7 text-teal-dark">
            {name}
            {credentials ? `, ${credentials}` : null}
          </h3>
        )}
        {board_title ? (
          <h4 className="text-center font-tertiary text-base italic leading-6 text-teal">{board_title}</h4>
        ) : null}
        <h4 className="text-center font-tertiary text-base italic leading-6 text-teal">{title}</h4>
      </div>
    </div>
  )
}

export function TeamMemberModal({ image, name, credentials, title, board_title, bio, group }) {
  const modalProps = useModal(slugify(`${name}-${group}`))
  return (
    <Modal {...modalProps}>
      <div className="lg:px-8">
        <div className="flex h-[100dvh] flex-col bg-white pb-12 pt-24 shadow-md sm:pb-0 lg:h-auto lg:rounded-10 lg:py-14">
          <div className="relative lg:flex lg:bg-springWood">
            <div className="h-32 bg-springWood lg:absolute lg:left-12 lg:top-1/2 lg:h-auto lg:-translate-y-1/2 lg:bg-transparent">
              <Image
                src={image?.filename && image.filename !== "" ? image.filename : "/assets/team-member-placeholder.png"}
                alt={image?.alt}
                placeholder={image?.blurDataURL ? "blur" : "empty"}
                blurDataURL={image?.blurDataURL}
                width={200}
                height={200}
                className="absolute -top-1/2 left-1/2 mx-auto aspect-square -translate-x-1/2 translate-y-1/2 rounded-full border-8 border-white object-cover object-top lg:static lg:mx-0 lg:translate-x-0 lg:translate-y-0"
              />
            </div>
            <div className="ml-auto mr-24 w-full px-6 pb-4 pt-11 lg:max-w-xl lg:px-0 lg:py-8">
              <h2 className="font-primary text-l1 text-teal-dark lg:text-l2">
                {name}
                {credentials ? `, ${credentials}` : null}
              </h2>
              {board_title ? (
                <h3 className=" text-center font-secondary text-l1 leading-6 text-teal lg:text-l2">{board_title}</h3>
              ) : null}
              <h3 className="font-secondary text-l1 text-teal lg:text-l2">{title}</h3>
            </div>
          </div>
          <div className="teal-scrollbar mr-6 overflow-y-scroll px-6 pb-8 sm:overflow-y-auto lg:ml-auto lg:mr-24 lg:max-w-xl lg:px-0 lg:pb-0 lg:pt-9">
            {richText(bio)}
          </div>
        </div>
      </div>
    </Modal>
  )
}
